interface Props {
  value: number;
  onChange: (v: number) => void;
}

const OPTIONS = [25, 50, 100, 200, 500];

export function RowLimitControl({ value, onChange }: Props) {
  return (
    <label className="flex flex-col text-xs text-subtext1">
      Wierszy
      <select
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="mt-1 rounded border border-surface1 bg-surface0 px-2 py-1 text-sm text-text outline-none focus:border-primary"
      >
        {OPTIONS.map((n) => (
          <option key={n} value={n}>
            {n}
          </option>
        ))}
      </select>
    </label>
  );
}
